<template>
  <div>
    <el-dialog
      :title="'红包账户明细—' + row.name"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="1250px"
    >
      <el-form ref="filterForm" :model="formData" inline size="small" class="el-form-group el-form-group_isRound" style="margin-bottom: 20px">
        <el-form-item label="账单类型" prop="opt" label-width="85px" style="margin: 0" >
          <el-select v-model="formData.opt" clearable round @change="getShanps">
            <el-option v-for="item in optOption" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="账单子类型" prop="serType" label-width="100px" style="margin: 0">
          <el-select v-model="formData.serType" filterable clearable>
            <el-option
              v-for="item in shanpsSelectList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="账单时间" prop="entryTime" label-width="85px" style="margin: 0">
          <el-date-picker
            v-model="formData.entryTime"
            type="daterange"
            :picker-options="pickerOptions"
            :editable="false"
            start-placeholder="开始日期"
            range-separator="~"
            end-placeholder="结束日期"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
          />
        </el-form-item>
        <el-button type="primary" size="small" style="margin-left: 10px" round @click="getList()">查询</el-button>
      </el-form>
      <el-button icon="el-icon-download" type="primary" size="small" style="float:right; margin-bottom: 20px" :loading="exportLoading"
 @click="exportExcel">导出明细</el-button>

      <GlobalTable
        ref="GlobalTable"
        v-loading="loading"
        :columns="redenvelopeslisttitle"
        :data="this.redenvedata"
        :currentPage="pageNum"
        :total="total"
        @handleCurrentChange="getList"
      >
        <el-table-column label="账单类型" slot="opt" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.opt == "01" ? "入账" : "出账" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="账单子类型" slot="title" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.title || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column width="100" label="员工姓名" slot="staffName" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.staffType == '01'" class="staffNamebox" style="background: #ffaf29">{{ row.isMajor ? '创建人' : '子账号' }}</span>
            <span v-else-if="row.staffType == '02'" class="staffNamebox" style="background: #81c26a">总监</span>
            <span>{{ row.staffName || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="账单金额(元)" slot="amount" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.amount || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="账单时间" slot="createTime" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.createTime || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="订单编号" slot="orderNo" align="center">
          <template slot-scope="{ row }">
            <span
              v-if="row.orderChannel == 'recycle'"
              style="
                text-decoration: underline;
                cursor: pointer;
                color: #0981ff;
              "
              @click="handleClick(row)"
              >{{ row.orderNo || "--" }}</span
            >
            <span v-if="row.orderChannel != 'recycle'">{{row.orderNo || "--"}}</span>
          </template>
        </el-table-column>
      </GlobalTable>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import _api from "@/utils/request";

export default {
  name: "ManageStatisticDia",
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      row: {},
      
      formData: {
        opt: '',
        serType: '',
        entryTime: [
          moment(
            moment().day(moment().day() - 6).format("YYYY-MM-DD 00:00:00")
          ).format('x'),
          moment(
            moment().format("YYYY-MM-DD 23:59:59")
          ).format('x'),
        ]
      },
      pickerMinDate: null,
      pickerMaxDate: null,
      day31: 30 * 24 * 3600 * 1000,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (
                time.getTime() > this.pickerMinDate + this.day31 ||
                time.getTime() < this.pickerMinDate - this.day31
            );
          }
          return false;
        },
      },
      initData: {
        entryTime: [
          moment().day(moment().day() - 6).format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ]
      },

      pageNum: 1,
      total: 0,
      redenvedata: [],
      shanpsSelectList: [],
      redenvelopeslist: [
        { slotName: "serType" },
        {
          key: "entryTime",
          type: "pickerOptions",
          labelName: "账单时间",
          placeholder: "请选择时间",
          valueFormat: "timestamp",
          lableWidth: "85px",
          pickerOptions: {
            onPick: ({ maxDate, minDate }) => {
              if (minDate && this.pickerMinDate) {
                this.pickerMinDate = null;
              } else if (minDate) {
                this.pickerMinDate = minDate.getTime();
              }
            },
            disabledDate: (time) => {
              if (this.pickerMinDate) {
                return (
                    time.getTime() > this.pickerMinDate + this.day31 ||
                    time.getTime() < this.pickerMinDate - this.day31
                );
              }
              return false;
            },
          },
        },
        {
          slotName: "botton",
        },
      ],
      redenvelopeslisttitle: [
        { slotName: "opt" }, // 类型
        { slotName: "title" }, // 类型
        { slotName: "staffName" },
        { label: "手机号", prop: "staffMobile" },
        { slotName: "amount" }, // 入账金额
        { slotName: "redpacketAudit" }, // 提现审核人
        {
          slotName: "withdrawChannel",
        },
        {
          slotName: "alipayAccount",
        },
        { slotName: "createTime" }, // 出账入账时间
        { label: "流水单号", prop: "uniqNo" },
        { slotName: "orderNo" }, // 提现单号
      ],
      optOption: [
        {
          label: "入账",
          value: "01",
        },
        {
          label: "出账",
          value: "02",
        },
      ],
      exportLoading: false
    };
  },
  methods: {
    open(row) {
      this.row = row;
      this.$refs['filterForm']?.resetFields()
      this.getShanps()
      this.getList()
      this.visible = true;
    },
    getList(pageNum = 1) {
      this.loading = true;
      const [startTime, endTime] = this.formData.entryTime || []
      _api.redpacketdetail({
        ...this.formData,
        pageNum,
        pageSize: 10,

        staffId: this.row.id,
        isManager: true,
        isFrozen: false,
        startTime, endTime, entryTime: undefined
      })
      .then((res) => {
        this.redenvedata = res.data.records;
        this.pageNum = res.data.current;
        this.total = res.data.total;
      })
      .finally(() => {
        this.loading = false;
      });
    },
    // 订单编号跳转详情
    handleClick(row) {
      let routeData = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row.orderNo },
      });
      window.open(routeData.href, "_blank");
    },
    getShanps() {
      this.formData.serType = ''
      _api.redpacketgetSerTypeList({
        isManager: true, isFrozen: false,
        opt: this.formData.opt
      }).then((res) => {
        this.shanpsSelectList = res.data;
      });
    },
    // 导出订单方法
    exportExcel(e) {

      // const redenvelopeslist = {
      //   startTime: this.datalist.startTime || this.entryTime[0],
      //   endTime: this.datalist.endTime || this.entryTime[1],
      //   opt: this.opt,
      //   isFrozen: this.isFrozen,
      //   pageNum: this.page3.pageNum,
      //   pageSize: 10,
      //   staffName: this.datalist.staffName || "",
      //   staffMobile: this.datalist.staffMobile || "",
      //   storeId: this.iiid,
      //   serType: this.idArr,
      //   isManager: this.isManager
      // };
      const [startTime, endTime] = this.formData.entryTime || []
      this.exportLoading = true
      _api.redpacketdetailexcel({
        ...this.formData,
        
        staffId: this.row.id,
        isManager: true,
        isFrozen: false,
        startTime, endTime, entryTime: undefined
      }).then((res) => {
        console.log(res);
        const content = res;
        const blob = new Blob([content]);

        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          //
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$alert(data.msg, "错误提示", {
                type: "error",
              });
            }
          } catch (err) {
            let start = moment(Number(startTime)).format(
                "YYYY.MM.DD"
            );
            let end = moment(Number(endTime)).format(
                "YYYY.MM.DD"
            );
            const fileName = `【红包账户明细】${start || ""}${end ? "-" + end : ""}.xlsx`;
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
      }).finally(() => {
            this.exportLoading = false;
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.verify-title {
  color: #0981ff;
  line-height: 16px;
  font-size: 16px;
  padding-left: 10px;
  border-left: 3px solid;
  margin-bottom: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}

.staffNamebox {
  padding: 2px 4px;
  border-radius: 4px;
  margin-right: 5px;
  color: #fff;
}

.link {
  text-decoration: underline;
  cursor: pointer;
  &.primary {
    color: #0981ff;
  }
  &.danger {
    color: #ff687b;
  }
}
</style>